<div class="row" style="padding:20px">
    <div class="col-md-12">
        <app-dynamic-grid [gridCols]="cols" [gridData]="tableData" [showFilter]="true">
        </app-dynamic-grid>
    </div>
</div>